import React, { useContext, useEffect, useState } from "react";
import logo from "../Assets/img/logo.png";
import { Link } from "react-router-dom";
import { ApiDataContext } from "../Contexts/ApiData";
import { URL_PATH } from "../Utils/Constants/constants";
import ImageSubstitute from "./ImageSubstitute";

const Header = () => {
  const [showSearch, setshowSearch] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const isSmallScreen = screenWidth < 1200;
  const apiData = useContext(ApiDataContext);

  const FullAddress = apiData?.layout?.Address;
  const ContactInfo = apiData?.layout?.Mobilenumber;
  const isHeaderLoading = apiData?.isHeaderLoading;

  const handleSearch = (e) => {
    e.preventDefault();
    alert("Please try again later.");
  };
  const toggleAttributes = {
    "data-toggle": "collapse",
    "data-target": "#navbarSupportedContent",
    "aria-controls": "navbarSupportedContent",
    "aria-expanded": false,
    "aria-label": "Toggle navigation",
  };

  useEffect(() => {
    setScreenWidth(window.innerWidth);
  }, [window.innerWidth]);

  return (
    <header className="header-aimc">
      <div>
        <nav className="navbar navbar-expand-xl navbar-light">
          <Link className="navbar-brand mob-logo" to="/">
            <img src={logo} alt="" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded={false}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="navbar-collapse collapse" id="navbarSupportedContent">
            <div className="header-top">
              <div className="container-fluid">
                <div className="header-top-area">
                  {/* <ul className="header-left">
                    <li>
                      <i className="fas fa-phone-alt"></i>
                      <span>
                        {isHeaderLoading ? (
                          <Spinner size="sm" />
                        ) : (
                          ContactInfo ?? ""
                        )}
                      </span>
                    </li>
                    <li>
                      <i className="fas fa-map-marker-alt"></i>
                      {isHeaderLoading ? (
                        <Spinner size="sm" />
                      ) : (
                        FullAddress ?? ""
                      )}
                    </li>
                  </ul> */}
                  <ul className="header-left">
                    <li>
                      <a href="https://facebook.com/" target="_blank">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href="http://instagram.com/" target="_blank">
                        <i className="fab fa-instagram"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://x.com/" target="_blank">
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://linkedin.com" target="_blank">
                        <i className="fab fa-linkedin-in"></i>
                      </a>
                    </li>
                  </ul>
                  <ul className="social-icons d-flex">
                    <li>
                      {isSmallScreen ? (
                        <Link to={URL_PATH.news} {...toggleAttributes}>
                          News
                        </Link>
                      ) : (
                        <Link to={URL_PATH.news}>News</Link>
                      )}
                    </li>
                    <li>
                      {isSmallScreen ? (
                        <Link to={URL_PATH.events} {...toggleAttributes}>
                          {" "}
                          Events
                        </Link>
                      ) : (
                        <Link to={URL_PATH.events}> Events</Link>
                      )}
                    </li>
                    <li>
                      {isSmallScreen ? (
                        <Link to={URL_PATH.donation} {...toggleAttributes}>
                          Donations
                        </Link>
                      ) : (
                        <Link to={URL_PATH.donation}>Donations</Link>
                      )}
                    </li>
                    <li>
                      {isSmallScreen ? (
                        <Link
                          to="/login?redirect=matrimonial"
                          {...toggleAttributes}
                        >
                          Matrimonial
                        </Link>
                      ) : (
                        <Link to="/login?redirect=matrimonial">
                          Matrimonial
                        </Link>
                      )}
                    </li>
                    <li>
                      {isSmallScreen ? (
                        <Link to={URL_PATH.jobs} {...toggleAttributes}>
                          Job & Vacancy
                        </Link>
                      ) : (
                        <Link to={URL_PATH.jobs}>Job & Vacancy</Link>
                      )}
                    </li>
                    <li>
                      {isSmallScreen ? (
                        <Link to={URL_PATH.membership} {...toggleAttributes}>
                          Join us
                        </Link>
                      ) : (
                        <Link to={URL_PATH.membership}>Join us</Link>
                      )}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="container-fluid">
              <div className="header-tow">
                <div className="desktop-logo">
                  {isSmallScreen ? (
                    <Link
                      className="navbar-brand"
                      to={URL_PATH.home}
                      {...toggleAttributes}
                    >
                      <img src={logo} alt="" />
                    </Link>
                  ) : (
                    <Link className="navbar-brand" to={URL_PATH.home}>
                      <img src={logo} alt="" />
                    </Link>
                  )}
                </div>
                <ul className="navbar-nav">
                  <li className="nav-item">
                    {isSmallScreen ? (
                      <Link
                        className="nav-link"
                        to={URL_PATH.home}
                        {...toggleAttributes}
                      >
                        Home
                      </Link>
                    ) : (
                      <Link className="nav-link" to={URL_PATH.home}>
                        Home
                      </Link>
                    )}
                  </li>
                  <li className="nav-item">
                    {isSmallScreen ? (
                      <Link
                        className="nav-link"
                        to={URL_PATH.history}
                        {...toggleAttributes}
                      >
                        Our History
                      </Link>
                    ) : (
                      <Link className="nav-link" to={URL_PATH.history}>
                        Our History
                      </Link>
                    )}
                  </li>
                  <li className="nav-item">
                    {isSmallScreen ? (
                      <Link
                        className="nav-link"
                        to={URL_PATH.coreCommittes}
                        {...toggleAttributes}
                      >
                        Core Committee
                      </Link>
                    ) : (
                      <Link className="nav-link" to={URL_PATH.coreCommittes}>
                        Core Committee
                      </Link>
                    )}
                  </li>
                  <li className="nav-item">
                    {isSmallScreen ? (
                      <Link
                        className="nav-link"
                        to={URL_PATH.social}
                        {...toggleAttributes}
                      >
                        Social Responsibility
                      </Link>
                    ) : (
                      <Link className="nav-link" to={URL_PATH.social}>
                        Social Responsibility
                      </Link>
                    )}
                  </li>
                  <li className="nav-item">
                    {isSmallScreen ? (
                      <Link
                        className="nav-link"
                        to={URL_PATH.gallery}
                        {...toggleAttributes}
                      >
                        Gallery
                      </Link>
                    ) : (
                      <Link className="nav-link" to={URL_PATH.gallery}>
                        Gallery
                      </Link>
                    )}
                  </li>
                  <li className="nav-item">
                    {isSmallScreen ? (
                      <Link
                        className="nav-link"
                        to={URL_PATH.about}
                        {...toggleAttributes}
                      >
                        About Us
                      </Link>
                    ) : (
                      <Link className="nav-link" to={URL_PATH.about}>
                        About Us
                      </Link>
                    )}
                  </li>
                  <li className="nav-item">
                    {isSmallScreen ? (
                      <Link
                        className="nav-link"
                        to={URL_PATH.contact}
                        {...toggleAttributes}
                      >
                        Contact us
                      </Link>
                    ) : (
                      <Link className="nav-link" to={URL_PATH.contact}>
                        Contact us
                      </Link>
                    )}
                  </li>
                </ul>
                <div className="navbar-icon">
                  {/* <a
                    className="nav-link navbar-icon-bg"
                    href="#"
                    title=""
                    onClick={(e) => {
                      e.preventDefault();
                      setshowSearch((prvs) => !prvs);
                    }}
                  >
                    <i className="fas fa-search" id="search-bar-btn"></i>
                  </a> */}
                  <form
                    className={`search-bar ${showSearch ? "d-block" : ""}`}
                    id="header-search"
                    onSubmit={handleSearch}
                  >
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        name="searchTxt"
                        placeholder="Search"
                      />
                      <div className="input-group-append">
                        <button className="btn" type="submit">
                          <i className="fas fa-search"></i>
                        </button>
                      </div>
                    </div>
                    {/* <input
                      name="__RequestVerificationToken"
                      type="hidden"
                      value="CfDJ8IU_NwcdqFxMjmxQM8xgjwFo8vOxx2ly6lKV4JDrMDunfy3hEfCtga-hV5h8xVp7-7oZMPXu7XEP9BBbzef5RieY_SfbzZQParMe3eclyr6qPu_3h69cs2lON3wdTZIyEaberMDdED4OIXQ4Kcg58XA"
                    /> */}
                  </form>
                  <Link
                    className="nav-link navbar-icon-bg"
                    to={URL_PATH.login}
                    title=""
                  >
                    {apiData.userName ? (
                      <div className="rounded-circle overflow-hidden border border-secondary">
                        <ImageSubstitute
                          xs
                          background={"#019040"}
                          name={apiData.userName}
                        />
                      </div>
                    ) : (
                      <i className="fas fa-user"></i>
                    )}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
